import React from 'react';
import { motion } from "framer-motion";
import { ImageFormComponent } from './menimagesform';
import { DatalistInput, fillerprofiledata, generateUUID, postData } from './misc.js';
import "./../kanit.css";
import { useParams } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha'
import { Loader } from './profile.js';

function fillerfunction () {
    // pretends to do something so form doesnt auto submit after option select
    console.log('Ayo')
}

function CoolOption(props) {
    const [selected, setSelected] = React.useState(props.alreadyselected || false)
    console.log("Rerendering ", selected)
    
    function onselection() {
        setSelected(true)
        
        if (props.text === "Other") {
            props.setSelectedOther(true)
            props.setField('', props.fieldid, "choice", props.pick, props.numberselected, props.setNumberSelected)
            props.setItemFilled(false)
        } else {
            props.setField(props.text, props.fieldid, "choice", props.pick, props.numberselected, props.setNumberSelected)
            props.setItemFilled(true)

            console.log("Number to pick: ", props.pick)
            console.log("Number selected: ", props.numberselected)

            setTimeout(function () {
                if (props.numberselected+1 >= props.pick) {
                    props.nextstep()
                }
            }, 1000)
        }
    }

    function onDeselection () {
        setSelected(false)
        props.setItemFilled(False)
        props.setField(props.text, props.fieldid, "choice", props.pick, props.numberselected, props.setNumberSelected)
    }

    return (
        <>
            {selected
                ? <button className="w-full p-2 mb-2 bg-green-300 border-white text-black kanit rounded-full" onClick={() => onDeselection()}>{props.text}</button>
                : <button className="w-full p-2 mb-2 bg-white border-white text-black kanit rounded-full" onClick={() => onselection()}>{props.text}</button>
            }
        </>
    )
}

function GeneratorFormQuestion(props) {
    function checkifanswerisntoftheoptions() {
        if (props.item.type === "choice") {
            const field = props.answers[props.item.fieldid]
            if (field) {
                const items = props.item.answers
                if (!items.includes(field)) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        } else {
            return false
        }
    }

    function settofilledornot() {
        if (props.item.type === "image") {
            return true
        } else if (props.item.type === "captcha") {
            return true
        } else if (props.item.type === "choice") {
            return false
        } else {
            return false
        }
    }

    const recaptcha = props.recaptcha
    const [numberselected, setNumberSelected] = React.useState(0)
    const [rangeslider, setRangeSlider] = React.useState(props.answers[props.item.fieldid] || 18)
    const [selectedother, setSelectedOther] = React.useState(checkifanswerisntoftheoptions())
    const [itemfilled, setItemFilled] = React.useState(settofilledornot())
    const pick = props.item.pick || 1

    function checkfieldisntpresent(thefield, valuetocheck, valuecorrectimportant) {
        const field = props.answers[thefield]
        if (field) {
            const isvalue = field === valuetocheck 
            if (valuecorrectimportant) {
                return isvalue
            } else {
                return true
            }
        } else {
            return false
        }
    }

    function controlledupdate(value, fieldid) {
        props.setField(value, fieldid)
        if (value) {
            setItemFilled(true)
        }
    }

    function gotonextstep() {
        console.log("all required: ", props.allrequired)
        if (!props.allrequired === false && !props.laststep) {
            if (itemfilled) {
                props.ForwardStep()
            } else {
                alert(`You have not filled the field: ${props.item.question}. Please do.`)
            }
        } else {
            props.ForwardStep()
        }
    }

    function renderAccQuestion() {
        if (props.item.type === "choice") {
            return (
                <>
                {props.men
                    ? <>
                        {props.item.sectionshow
                            ? <p className="text-white text-xl mt-1 text-center">{props.item.section}</p>
                            : null
                        }
                        <p className="text-white text-base mb-2 text-center">{props.item.question}</p>
                      </>
                    : <>
                        <p className="text-white text-xl mt-1 text-center">{props.item.section}</p>
                        <p className="text-white text-base mb-2 text-center">{props.item.question}</p>
                      </>
                }
                
                {props.laststep
                    ? <>
                        {props.item.answers.map((item, index) => (
                            <CoolOption key={index}
                                text={item} setField={props.setField}
                                fieldid={props.item.fieldid} pick={pick} setItemFilled={setItemFilled}
                                numberselected={numberselected} setNumberSelected={setNumberSelected}
                                nextstep={fillerfunction} setSelectedOther={setSelectedOther}
                                alreadyselected={checkfieldisntpresent(props.item.fieldid, item, true)}/>
                        ))}
                      </>
                    : <>
                        {props.item.answers.map((item, index) => (
                            <CoolOption key={index}
                                text={item} setField={props.setField}
                                fieldid={props.item.fieldid} pick={pick} setItemFilled={setItemFilled}
                                numberselected={numberselected} setNumberSelected={setNumberSelected}
                                nextstep={props.ForwardStep} setSelectedOther={setSelectedOther}
                                alreadyselected={checkfieldisntpresent(props.item.fieldid, item, true)}/>
                        ))}
                      </>
                }

                {selectedother
                    ? <>
                        {checkifanswerisntoftheoptions()
                            ? <input className="bg-white text-black placeholder-gray-600 p-2 my-2 rounded-full" defaultValue={props.answers[props.item.fieldid]} placeholder={'Please expand:'} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                            : <input className="bg-white text-black placeholder-gray-600 p-2 my-2 rounded-full" placeholder={'Please expand:'} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                        }
                      </>
                    : null
                }
                
                {!props.firststep
                    ? <>
                        {props.men ? null 
                            : <div className="grid grid-cols-2 mt-3 gap-2">
                                <button onClick={() => props.MinusStep()} className="w-full text-black bg-white p-2 rounded-full">Prev</button>
                                <button onClick={() => gotonextstep()} className="w-full text-black bg-white p-2 rounded-full">Next</button>
                              </div>
                        }
                      </>
                    : null
                }
                </>
            )
        } else if (props.item.type === "age") {
            const min = props.item.min || 1
            const max = props.item.max || 150
            return (
                <>
                {props.item.sectionshow
                    ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                    : null
                }
                {props.men ? null
                    : <p className="text-white text-xl mt-1">{props.item.section}</p>
                }
                <label htmlFor="steps-range" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{props.item.question}: {rangeslider}</label>
                <input type="range" min={min} max={max} step="1" className="w-full h-2 bg-gray-200 mt-1 mb-3 rounded-lg appearance-none cursor-pointer" value={rangeslider} onChange={(e) => {setRangeSlider(e.target.value);controlledupdate(e.target.value, props.item.fieldid)}}/>
                </>
            )
        } else if (props.item.type === "pass") {
            return (
                <>
                    {props.men
                        ? <>
                            {props.item.sectionshow
                                ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                                : null
                            }
                            <input className="bg-white text-black placeholder-gray-600 p-2 my-2 rounded-full" placeholder={props.item.question+':'} type='password' defaultValue={props.answers[props.item.fieldid] || ""} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                          </>
                        : <>
                            <p className="text-white text-xl">{props.item.section}</p>
                            <p className="text-white text-base">{props.item.question}</p>
                            <input className="bg-white text-black placeholder-gray-600 p-2 rounded-full" placeholder='Enter Text:' type='password' onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                          </>
                    }
                </>
            )
        } else if (props.item.type === "longtext") {
            return (
                <>
                    {props.men
                        ? <>
                            {props.item.sectionshow
                                ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                                : null
                            }
                            <textarea className="bg-white text-black placeholder-gray-600 p-2 my-2 w-full h-64" placeholder={props.item.question+':'} type='password' defaultValue={props.answers[props.item.fieldid] || ""} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                          </>
                        : <>
                            <p className="text-white text-xl">{props.item.section}</p>
                            <p className="text-white text-base">{props.item.question}</p>
                            <textarea className="bg-white text-black placeholder-gray-600 p-2 w-full h-64" placeholder='Enter Text:' defaultValue={props.answers[props.item.fieldid] || ""} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                          </>
                    }
                </>
            )
        } else if (props.item.type === "image") {
            const fullname1 = props.answers.fullname1
            const EMAIL = props.answers.EMAIL
            const therandomUUID = generateUUID()
            console.log("Current State of things at image form component show.");
            console.log("Email:", EMAIL);
            console.log("Full name:", fullname1);
            console.log("ID:", therandomUUID);
            
            return (
                <>
                    {props.men
                        ? <>
                            {props.item.sectionshow
                                ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                                : null
                            }
                            <p className="text-white text-base mt-1">{props.item.question}</p>
                            <ImageFormComponent EMAIL={EMAIL} id={therandomUUID} fullname1={fullname1} allanswers={props.answers} gender={props.gender}/>
                          </>
                        : <>
                            <p className="text-white text-xl">{props.item.section}</p>
                            <p className="text-white text-base">{props.item.question}</p>
                            <ImageFormComponent EMAIL={EMAIL} id={therandomUUID} fullname1={fullname1} allanswers={props.answers} gender={props.gender}/>
                          </>
                    }
                </>
            )
        } else if (props.item.type === "captcha") {
            return (
                <>
                    <p className="text-white text-base mt-1">{props.item.question}</p>
                    <ReCAPTCHA ref={recaptcha} sitekey={"6LfTO2YqAAAAAEJnKMWW2zz_wK972wr7z4yZEVSh"} />
                </>
            )
        } else if (props.item.type === "datalistinput") {
            return (
                <>
                    {props.men
                        ? <>
                            {props.item.sectionshow
                                ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                                : null
                            }
                            
                            <DatalistInput 
                                id={props.item.fieldid} 
                                placeholder={props.item.question+':'}
                                onChange={function(text) {props.setField(text, props.item.fieldid)}}
                                options={props.item.answers}
                            />
                          </>
                        : <>
                            <p className="text-white text-xl">{props.item.section}</p>
                            <p className="text-white text-base">{props.item.question}</p>
                            <input className="bg-white text-black placeholder-gray-600 p-2 rounded-full" placeholder='Enter Text:' defaultValue={props.answers[props.item.fieldid] || ""} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                          </>
                    }
                </>
            )
        } else {
            return (
                <>
                    {props.men
                        ? <>
                            {props.item.sectionshow
                                ? <p className="text-white text-xl mt-1">{props.item.section}</p>
                                : null
                            }
                            <input className="bg-white text-black placeholder-gray-600 p-2 my-2  w-full rounded-full" placeholder={props.item.question+':'} defaultValue={props.answers[props.item.fieldid] || ""} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                          </>
                        : <>
                            <p className="text-white text-xl">{props.item.section}</p>
                            <p className="text-white text-base">{props.item.question}</p>
                            <input className="bg-white text-black placeholder-gray-600 p-2 rounded-full" placeholder='Enter Text:' defaultValue={props.answers[props.item.fieldid] || ""} onChange={(e) => controlledupdate(e.target.value, props.item.fieldid)}/>
                          </>
                    }
                </>
            )
        }
    }
    
    return (
        <>
        {props.showitem
            ? <motion.div 
                className="flex flex-col items-center justify-center"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{duration:1}}
              >
                {renderAccQuestion()}
                
                {props.rendersequentially
                    ? <>
                        {props.firststep
                            ? <button onClick={() => gotonextstep()} className="w-full text-black bg-white p-2 rounded-full mt-3">Next</button>
                            : <>
                                {props.item.type !== "choice"
                                    ? <div className="grid grid-cols-2 mt-3 gap-2">
                                        <button onClick={() => props.MinusStep()} className="w-full text-black bg-white p-2 rounded-full">Prev</button>
                                        <button onClick={() => gotonextstep()} className="w-full text-black bg-white p-2 rounded-full">Next</button>
                                      </div>
                                    : null
                                }
                              </>
                        }
                      </>
                    : null
                }

                {props.rendersequentially
                    ? null
                    : <>
                        {props.laststep
                            ? <>
                                <button onClick={() => props.SecondForwardStep()} className="w-full text-black bg-white p-2 rounded-full mt-3">Submit Profile</button>
                              </>
                            : null
                        }
                      </>
                }
                
              </motion.div>
            : null
        }
        </>
    )
}

export default function ProfileGenerator(props) {
    const recaptcha = React.useRef()
    const captchapresent = props.captchapresent || false 

    const [allanswers, setAllAnswers] = React.useState(fillerprofiledata())
    const [loading, setLoading] = React.useState(false)
    const [message, setMessage] = React.useState(false)
    const [currentstep, setCurrentStep] = React.useState(0)
    const [rawdata, setRawData] = React.useState("")
    const numberofsteps = props.allquestions.length
    
    function ForwardStep() {
        // 13 country
        console.log("Thew current step:", currentstep)
        if (currentstep === 29) {
            console.log("We have arrived at the skipping point")
            console.log("The value of the kids var: ", allanswers['children1'])
            if (allanswers['children1']) {
                if (allanswers['children1'][0]==="No") {
                    const storenextstep = currentstep + 2
                    setCurrentStep(storenextstep)
                } else {
                    const storenextstep = currentstep + 1
                    setCurrentStep(storenextstep)
                }
            } else {
                const storenextstep = currentstep + 1
                setCurrentStep(storenextstep)
            }
        } else {
            const storenextstep = currentstep + 1
            setCurrentStep(storenextstep)
        }
    }
    function MinusStep() {
        const storenextstep = currentstep - 1
        setCurrentStep(storenextstep)
    }

    function setField(value, field, type, picknumber, numberselected, setNumberSelected) {
        var currentanswers = allanswers;
        console.log("Newthing ", currentanswers);
        if (type !== 'choice') {
            var currentanswers = allanswers
            currentanswers[field] = value
            setAllAnswers(currentanswers)
            console.log(allanswers)
        } else {
            var currentanswers = allanswers
            console.log("Newthing ", currentanswers)
            if (!currentanswers[field]) {
                var currentanswers = allanswers
                currentanswers[field] = [value]

                setAllAnswers(currentanswers)
                setNumberSelected(numberselected + 1)

                console.log(allanswers)
                console.log(numberselected)
            } else {
                var currentanswers = allanswers
                var newlength = currentanswers[field].length +1 
                var currentlypresent = currentanswers[field] || []
                if (currentlypresent.includes(value)) {
                    currentlypresent = currentlypresent.filter(item => item !== value)
                    currentanswers[field] = currentlypresent

                    setAllAnswers(currentanswers)
                    setNumberSelected(numberselected-1)

                    console.log(allanswers)
                    console.log(numberselected)
                } else {
                    var currentanswers = allanswers
                    if (newlength>picknumber) {
                        alert("You've picked too many options, please deselect something first.")
                    } else {
                        currentlypresent.push(value)
                        currentanswers[field] = currentlypresent

                        setAllAnswers(currentanswers)
                        setNumberSelected(numberselected+1)

                        console.log(allanswers)
                        console.log(numberselected)
                    }
                }
            }
        }
    }

    function handleSubmit(event) {
        if (event) event.preventDefault()
        const url = props.signupurl;
        const formData = new FormData();
        var currentanswers = allanswers

        for (var key in currentanswers) {
            formData.append(key, currentanswers[key]) 
        }
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        console.log(formData)

        postData(url, formData, config).then((data) => {
            if (data.responsecode === 200) {
                window.location.reload()
            } else {
                alert("Something went wrong. Please contact support.")
            }
        }).catch((error) => {
            console.error("There was an error: ", error);
            alert("Something went wrong. Please contact support.")
            throw error;
        })
    }

    function handleGenerateSubmit(event) {
        if (event) event.preventDefault()
        setLoading(true)
        const url = props.url;
        const formData = new FormData();
        var currentanswers = allanswers
        
        if (!currentanswers['fullname1']) {
            currentanswers['fullname1'] = `${currentanswers['firstname1']} ${currentanswers['middlename1']} ${currentanswers['lastname1']}`
        }
        
        for (var key in currentanswers) {
            formData.append(key, currentanswers[key]) 
        }
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        
        console.log(formData)

        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                navigator.clipboard.writeText(data.profiletext)
                setField(data.profiletext, "futurespouse1")
                setLoading(false)
            } else {
                alert("Something went wrong. Please contact support.")
            }
        }).catch((error) => {
            console.error("There was an error: ", error);
            alert("Something went wrong. Please contact support.")
            throw error;
        })
    }

    function setcopyablecaption(text) {
        const url = '/sirri_api/aiprompts/generalizedprompts';
        const formData = new FormData();
        const actualtext = `Based on the script of a video dating profile I'm going to send you İ want you to generate an Instagram caption for the post that will help to drive post engagement and reach. Knowing that my audience is employed single or divorced women between the ages of 30-45 who live in East Africa, add the relevant hashtags. Put in a summary of what he said he's looking for in a woman as well. Don't include the word connection in the text or the hashtags. Keep the text excluding hashtags to one paragraphs. This is it: \n\n${text}`
        formData.append("context", "You are a professional copywriter tasked with coming up with great captions for instagram posts.")
        formData.append("prompt", actualtext)
        formData.append("numofresponses", 1)

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        
        console.log(formData)

        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                console.log("The response data from ai entiendo: ", data.data)
                setMessage(data.data[0])
            } else {
                alert("Something went wrong. Please contact support.")
            }
        })
    }

    function setProfiledataSubmit(event) {
        if (event) event.preventDefault()
        setLoading(true)
        const url = "/api/sirri_api/set_perfil_data";
        const formData = new FormData();
        formData.append("details", rawdata) 
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        
        console.log(formData)

        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                console.log("The response data from ai entiendo: ", data.data)
                for (var key in data.data) {
                    console.log("The key: ", key)
                    setField(data.data[key], key)
                    setLoading(false)
                }
            } else {
                alert("Something went wrong. Please contact support.")
            }
        }).catch((err) => {
            console.log("Error in setProfiledataSubmit: ", err);
            throw err;
        })
    }

    function clicktocopy () {
        navigator.clipboard.writeText(message)
        alert("Copied")
    }

    return (
            <div className="mb-3">
                <p className="text-white text-base mb-2 text-left">
                    Based on the data below I want you to generate a JSON object.<br/> 
                    - The occupation should be under a property name currentoccupation1 <br/>
                    - The age under age1 <br/>
                    - The nationality under ethnicity1 <br/>
                    - The city under city1 <br/>
                    - The country under country1 extrapolated from the city name. <br/>
                    - A full male first and second name, choose an uncommon name but one that comes from his nationality under the property name fullname1.<br/>
                    Respond ONLY with the JSON. Here is the data:
                </p>

                <textarea className="bg-white text-black placeholder-gray-600 p-2 w-full h-64" placeholder="Enter Text:" onChange={(e) => setRawData(e.target.value)} />
                {loading
                    ? <Loader/>
                    : null
                }
                <button className="bg-white text-black text-sm py-3 text-center w-full" onClick={() => setProfiledataSubmit()}>SET DATA</button>

                {props.allquestions.map(function(item, index) {
                    if (index === numberofsteps-1) {
                        return (
                            <GeneratorFormQuestion 
                                index={index} 
                                item={item} 
                                men={true}
                                ForwardStep={handleGenerateSubmit}
                                SecondForwardStep={handleSubmit} 
                                MinusStep={MinusStep} 
                                setField={setField}
                                laststep={true} 
                                key={index}
                                firststep={(index===0)} 
                                showitem={true}
                                rendersequentially={false}
                                answers={allanswers}
                                gender={props.gender}
                                recaptcha={recaptcha}
                                allrequired={props.allrequired}
                            />
                        )
                    } else {
                        return (
                            <GeneratorFormQuestion 
                                index={index} 
                                key={index}
                                item={item} 
                                men={true}
                                ForwardStep={ForwardStep} 
                                MinusStep={MinusStep} 
                                laststep={false}
                                setField={setField} 
                                firststep={(index===0)} 
                                showitem={true}
                                rendersequentially={false}
                                answers={allanswers}
                                gender={props.gender}
                                allrequired={props.allrequired}
                                recaptcha={recaptcha}
                            />
                        )
                    }
                })}
                
                <div className="bg-black rounded text-white items-center justify-center">
                {loading
                    ? <Loader/>
                    : null
                }
                </div>

                {/* <div className="bg-black m-3 w-full" onClick={() => clicktocopy()}>
                    <p className="text-white p-2" style={{whiteSpace:"pre-line"}}>{message}</p>
                    <button className="bg-white text-black text-sm py-3 text-center w-full">Click to copy</button>
                </div> */}
            </div>
    )
}
